/**
 * Global snackbar (toast) bus — works from class and function components.
 * Mount <AppSnackbar /> once in App; call showSnackbar / showError / etc.
 */

let listener = null;

// Register the mounted AppSnackbar listener
export const setSnackbarListener = (fn) => {
  listener = fn;
};

/**
 * Show a Material-UI snackbar toast.
 * @param {string} message
 * @param {'success'|'error'|'warning'|'info'} [severity='info']
 */
export const showSnackbar = (message, severity = 'info') => {
  const text = message == null ? '' : String(message).trim();
  if (!text || !listener) {
    return;
  }
  listener({
    open: true,
    message: text,
    severity,
  });
};

export const showSuccess = (message) => showSnackbar(message, 'success');
export const showError = (message) => showSnackbar(message, 'error');
export const showWarning = (message) => showSnackbar(message, 'warning');
export const showInfo = (message) => showSnackbar(message, 'info');

export default {
  showSnackbar,
  showSuccess,
  showError,
  showWarning,
  showInfo,
  setSnackbarListener,
};
